export const PAGE_HEIGHT_PDF = 1350;
export const PAGE_WIDTH_PDF = 900;
export const HEIGHT_TOLERANCE_PX = 0.5;
